import CoursesPicker from "src/components/NewComponents/Creator/ContentPicker/CoursesPicker";
import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

function CoursesPickerContainer() {
	return (
		<LayoutWithSearch>
			<CoursesPicker />
		</LayoutWithSearch>
	);
}

export default CoursesPickerContainer;
